module.exports = {"greenTemperature":"Green Temperature","hourlyGreenTemperature":"Hourly Green Temperature","periodGreenTemperature":"Green Temperature by Period","selectGolfClubPlaceholder":"Select a golf club.","selectTypePlaceholder":"Select a type.","lastUpdated":"Last Updated","refresh":"Refresh","noData":"No data available.","chartDateAxis":"Date","chartTemperatureAxis":"Temperature"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/gr101.json
// module id = Z9qT
// module chunks = 2